export default __webpack_public_path__ + "static/media/img2.82381021.jpg";